import { type ObjectValuesUnionType } from '../../../utils/typing';

export const GRBasketErrorCodes = Object.freeze({
  E_OP_NOT_RUNNING: 47000,
  E_USER_NOT_IN: 47001,
  E_SYSTEM_FORBIDDEN: 47003,
  E_MATCH_PENDING: 47004,
  E_START_DATE_OVER_48: 47005,
  E_BETSLIP_NOT_ELIGIBLE: 47006,
  E_INTERNAL_ERROR: 47007,
  E_START_DATE_OVER_OPE: 47008,
  E_USER_EXCLUDED: 47009,
  E_ALREADY_PAID: 47010,
  E_PAYMENT_ERROR: 47011,
  E_ALREADY_REGISTERED: 47012,
  E_ES_RM_J30: 47013,
  E_SELF_EXCLUDED: 47014,
});

export type GRBasketErrorCode = ObjectValuesUnionType<typeof GRBasketErrorCodes>;
